The details of the conflicting `CandidateProcessHistoryItem`.
